import {
  useStatsigBootstrapped,
  useStatsigClient,
  useStatsigTargetingReady,
} from '@rover/rsdk/src/modules/Statsig';
import { type SeasonId, isSeasonId } from '@rover/types/src/Season';

export const SEASONAL_THEME_CONFIG = 'seasonal_theme';

// Unbootstrapped, `null` on the server and until targeting applies, so SSR and hydration agree.
export function useActiveSeason(): SeasonId | null {
  const { client } = useStatsigClient();
  const isBootstrapped = useStatsigBootstrapped();
  const isTargetingReady = useStatsigTargetingReady();

  if (!isBootstrapped && (process.env.JS_ENV_SERVER || !isTargetingReady)) {
    return null;
  }

  const { seasonId } = client.getDynamicConfig(SEASONAL_THEME_CONFIG).value;
  return isSeasonId(seasonId) ? seasonId : null;
}
